import {
  ITEM_TO_BAG_ERROR_BAG_SIZE_EXCEEDED,
  ITEM_TO_BAG_ERROR_VOUCHER_IN_THE_BAG,
  ITEM_TO_BAG_ERROR_OUT_OF_STOCK,
  ITEM_TO_BAG_ERROR_BRAND_QUANTITY_EXCEEDED
} from "../../../../../state/modules/savedItems/constants";
import content from "app-content";

const getItemToBagErrorMessage = ({ errorCode, errorMessage }) => {
  const knownCodeMap = {
    [ITEM_TO_BAG_ERROR_BAG_SIZE_EXCEEDED]:
      content.saved_items_move_to_bag_failure_maxitemsinbag,
    [ITEM_TO_BAG_ERROR_VOUCHER_IN_THE_BAG]:
      content.saved_items_move_to_bag_failure_voucherinbag,
    [ITEM_TO_BAG_ERROR_OUT_OF_STOCK]:
      content.saved_items_move_to_bag_failure_out_of_stock,
    [ITEM_TO_BAG_ERROR_BRAND_QUANTITY_EXCEEDED]: errorMessage
  };

  return (
    knownCodeMap[errorCode] || content.saved_items_move_to_bag_generic_failure
  );
};

export default getItemToBagErrorMessage;
